<div class="textSubscription desktop" *ngIf="!IsViewMode">{{'SUBSCRIPTION.ROUTE_SELECTION_TEXT'|translate}}</div>
<div class="row cards-container">
  <p-tabView #tabs [(activeIndex)]="activateIndex" >
    <p-tabPanel *ngIf="IsViewMode || rouletteWebSubscriptions?.length > 0" header="{{'SUBSCRIPTION.ROULETTE_FOR_WEB'|translate}}">
  <div class="roulette-card" [ngClass]="{selected:true}" *ngFor="let subscription of rouletteWebSubscriptions">
  
    <img class="bg-img" src="assets/images/roulette-card-bg-{{subscription.color}}.svg" />
    <div *ngIf="subscription.IsCurrentAvailableSubscription" class="selected"> {{'SUBSCRIPTION.CURRENT'|translate}}
    </div>
    <div class="header column">
      <span>{{subscription.NamePackage}}</span>
      <span
        class="spins-count">{{subscription.SpinsCount>0?(subscription.SpinsCount|appendtext:('SUBSCRIPTION.SPINS'|translate))
        :('SUBSCRIPTION.NO_SPINS_LIMIT'|translate)}}</span>
    </div>
    <div class="row details-row full-width">
      <span>{{'SUBSCRIPTION.ROULETTE_EXPIRE'|translate}}</span>
      <span *ngIf="subscription.ExpireDays>0">{{subscription.ExpireDays|appendtext:('ROULETTE.DAYS'|translate)}}</span>
      <span *ngIf="!(subscription.ExpireDays>0)">{{'SUBSCRIPTION.NOEXPIRE'|translate}}</span>
    </div>
    <div class="row details-row full-width">
      <span>{{'SUBSCRIPTION.CUSTOMERS_DATABASE'|translate}}</span>
      <span class="size-value">{{ 'SUBSCRIPTION.' + subscription.customersDatabase | translate }}</span>
    </div>
    <div class="price column">
      <span *ngIf="subscription.IsFreePackage && subscription.IsAllowToSendCampain">0 ₪</span>
      <span *ngIf="subscription.IsFreePackage && !subscription.IsAllowToSendCampain">{{'SUBSCRIPTION.FREEPRICE'|translate}}</span>
      <span
        *ngIf="!subscription.IsFreePackage">{{subscription.Price|currency:curencyEnum[subscription.Currency]}}</span>
      <span class="sub-price">{{'SUBSCRIPTION.MONTHLY_PAYMENT'|translate}}</span>
    </div>
    <!-- Show message for campaign package -->
    <div class="campaign-message" *ngIf="subscription.IsAllowToSendCampain && subscription.RemainingCampaignRoulettes !== undefined">
      <span>{{'SUBSCRIPTION.CAMPAIGN_ELIGIBILITY'|translate:{count:subscription.RemainingCampaignRoulettes} }}</span>
    </div>
    <!-- Hide switches for free campaign package -->
    <div id="switch-container" *ngIf="!subscription.IsAllowToSendCampain">
      <div class="row r-form-group switch-container" id="switch">
        <label for="IsYearlyPackage" class="title bold-text" id="labelForMonth">
          {{'ROULETTE.YEARLY_SUBSCRIPTION'|translate:{price:subscription.PriceForYear|currency:curencyEnum[subscription.Currency]}
          }}
        </label>
        <p-inputSwitch name="IsYearlyPackage" [(ngModel)]="subscription.IsYearlyPackage"></p-inputSwitch>
      </div>

      <span id="discount" *ngIf="subscription.Discount">{{
        'ROULETTE.YEARLY_SALE'|translate:{price:subscription.Discount|currency:curencyEnum[subscription.Currency]}
        }}</span>
      <div *ngIf="!subscription.IsYearlyPackage" id="switch" class="row r-form-group switch-container">
        <label class="title bold-text" id="labelForMonth"
          for="autoRenewal">{{'ROULETTE.AUTOMATIC_RENEWAL_AT_THE_END_OF_THE_PERIOD'|translate}}</label>
        <p-inputSwitch name="autoRenewal" [(ngModel)]="subscription.AutoRenewalPackage"></p-inputSwitch>
      </div>
    </div>
    <button id="choose" class="command-button full full-width" blockButtonToSingleClick [blockButtonTime]="3000"
      [disabled]="subscription.IsAllowToSendCampain && subscription.RemainingCampaignRoulettes === 0"
      (click)="selectSubscription(subscription)">
      {{'SUBSCRIPTION.SELECTION' | translate}}
    </button>
  </div>
    </p-tabPanel>
    <p-tabPanel *ngIf="IsViewMode || rouletteFrontalSubscriptions?.length > 0" header="{{'SUBSCRIPTION.ROULETTE_FOR_FRONTAL_USE'|translate}}">
      <div class="roulette-card"  [ngClass]="{selected:true}" *ngFor="let subscription of rouletteFrontalSubscriptions; let i = index">
  
        <img class="bg-img" src="assets/images/roulette-card-bg-{{subscription.color}}.svg" />
        <div *ngIf="subscription.IsCurrentAvailableSubscription" class="selected"> {{'SUBSCRIPTION.CURRENT'|translate}}
        </div>
        <div class="header column">
         
          <span
            class="spins-count">{{subscription.NamePackage}}</span> 
            <span class="plan-details">{{('SUBSCRIPTION.PLAN_DETAILS'|translate)}}</span>
        </div>
        <div class="subscription-details">
          <div class="detail-row">
            <img src="assets/images/icons/v-icon.svg" alt="icon"/>
            <span>{{'SUBSCRIPTION.' + ( i===0 ? '500_SPINS_FOR_MONTH' :'UNLIMITED_SPINS' ) | translate}}</span>
          </div>
        
          <div class="detail-row">
            <img src="assets/images/icons/v-icon.svg" alt="icon"/>
            <span>{{'SUBSCRIPTION.' + ( i===0 ? 'ONE_TIME_PROFESSIONAL_CONSULATION' : i===1 ? 'QUARTERLY_PROFESSIONAL_CONSULATION' : 'MONTHLY_PROFESSIONAL_CONSULATION') | translate}}</span>
          </div>
        
          <div class="detail-row">
            <img src="assets/images/icons/v-icon.svg" alt="icon"/>
            <span>{{'SUBSCRIPTION.' + ( i===0 ? 'PROFESSIONAL_SALES_BASIC' : i===1 ? 'PROFESSIONAL_SALES_PREMIUN' : 'PROFESSIONAL_SALES_VIP') | translate}}</span>
          </div>
        
          <div class="detail-row">
            <!-- <img src="assets/images/icons/v-icon.svg" alt="icon"/> -->
            <img [src]="i === 0 ? 'assets/images/icons/x-icon.svg' : 'assets/images/icons/v-icon.svg'" alt="icon"/>

            <span *ngIf="i===0 || i===1">{{ ( i===0 ? 'SUBSCRIPTION.NO_BUSINESS_MENTORING' :  'SUBSCRIPTION.QUARTERLY_BUSINESS_MENTORING') | translate}}</span>
            <span *ngIf="i===2" class="bold-text" >{{'SUBSCRIPTION.FULL_BUSINESS_MENTORING' | translate}}</span>
          </div>
        </div>
        
           <div class="price column">
          <span *ngIf="subscription.IsFreePackage">{{'SUBSCRIPTION.FREEPRICE'|translate}}</span>
       
          <span
            *ngIf="!subscription.IsFreePackage">{{subscription.Price|currency:curencyEnum[subscription.Currency]}}</span>
          <span class="sub-price">{{'SUBSCRIPTION.MONTHLY_PAYMENT'|translate}}</span>
        </div>

        <button id="chooseFrontal" class="command-button full full-width" blockButtonToSingleClick [blockButtonTime]="3000"
          (click)="selectSubscription(subscription)">
          {{'SUBSCRIPTION.SELECTION' | translate}}
        </button>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
<div class="returnLink" *ngIf="!IsViewMode">
  <a class="link" (click)="back()">{{'SUBSCRIPTION.RETURN_TO_PREVIOUS_PAGE'|translate}}</a>
</div>
